import { useState, useEffect } from 'react';
import { type Breakpoint, classify_width } from './use_breakpoint_utils';

export type { Breakpoint };
export type { Device } from './use_breakpoint_utils';

export function useBreakpoint(): Breakpoint {
  const [state, setState] = useState<Breakpoint>(() => {
    if (typeof window === 'undefined')
      return { device: 'desktop', width: 1280 };
    const width = window.innerWidth;
    return { device: classify_width(width), width };
  });

  useEffect(() => {
    function handle() {
      const width = window.innerWidth;
      setState({ device: classify_width(width), width });
    }
    window.addEventListener('resize', handle);
    return () => {
      window.removeEventListener('resize', handle);
    };
  }, []);

  return state;
}
